function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
// Imports
import { Route, BrowserRouter as Router } from 'react-router-dom';
import Panel from '@engine/components/presentational/base/panel';
import React from 'react';
import RiskFilterSettingsProvider from '@engine/components/containers/risk-filter-settings-provider';
import RiskFiltersListSearch from '@engine/components/containers/risk-filters-list-search';

var ShieldIcon = function ShieldIcon(props) {
  return React.createElement("svg", props, React.createElement("path", {
    d: "M12.92 15a.56.56 0 0 0-.09-.17l-.12-.15a1 1 0 0 0-1.42 0 .61.61 0 0 0-.12.15.56.56 0 0 0-.09.17.7.7 0 0 0-.06.19 1.23 1.23 0 0 0 0 .19.88.88 0 0 0 .08.39 1 1 0 0 0 1.3.54 1.19 1.19 0 0 0 .33-.22 1 1 0 0 0 .21-.32 1 1 0 0 0 .08-.39 1.23 1.23 0 0 0 0-.19.7.7 0 0 0-.1-.19zM12 7.36a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1zm7.63-3.71a1 1 0 0 0-.84-.2 8 8 0 0 1-6.22-1.27 1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27 1 1 0 0 0-.84.2 1 1 0 0 0-.37.78v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 20 11.88V4.43a1 1 0 0 0-.37-.78zM18 11.88a7 7 0 0 1-2.93 5.7L12 19.77l-3.07-2.19A7 7 0 0 1 6 11.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39z"
  }));
};

ShieldIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import { connect } from 'react-redux';

var RiskFiltersConfigurationWizard = /*#__PURE__*/function (_React$Component) {
  _inherits(RiskFiltersConfigurationWizard, _React$Component);

  var _super = _createSuper(RiskFiltersConfigurationWizard);

  function RiskFiltersConfigurationWizard() {
    _classCallCheck(this, RiskFiltersConfigurationWizard);

    return _super.apply(this, arguments);
  }

  _createClass(RiskFiltersConfigurationWizard, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement("div", {
        className: "row"
      }, React.createElement(Router, null, React.createElement(Route, {
        exact: true,
        path: "*/terminals/:id/risk_filters/new",
        render: function render(routerParams) {
          return React.createElement(React.Fragment, null, React.createElement(RiskFiltersListSearch, {
            filtersList: _this.props.riskFiltersClasses,
            baseUrl: routerParams.match.url
          }), React.createElement("div", {
            className: "col-xl-9 col-lg-9 col-md-9 col-sm-9"
          }, React.createElement(Panel.Container, null, React.createElement("div", {
            className: "risk-filters-configuration-blank"
          }, React.createElement("span", null, "New Risk Filter"), React.createElement(ShieldIcon, null), React.createElement("span", null, "Please, select risk filter from the list.")))));
        }
      }), React.createElement(Route, {
        path: "*/terminals/:id/risk_filters/new/:filterClass",
        render: function render(routerParams) {
          return React.createElement(React.Fragment, null, React.createElement(RiskFiltersListSearch, {
            activeFilterClass: routerParams.match.params.filterClass,
            filtersList: _this.props.riskFiltersClasses,
            baseUrl: routerParams.match.url.replace('/' + routerParams.match.params.filterClass, '')
          }), React.createElement(RiskFilterSettingsProvider, {
            fetchUrl: _this.props.fetchUrl,
            filterClass: routerParams.match.params.filterClass,
            formUrl: _this.props.formUrl,
            redirectUrl: _this.props.redirectUrl
          }));
        }
      })));
    }
  }]);

  return RiskFiltersConfigurationWizard;
}(React.Component);

export default connect()(RiskFiltersConfigurationWizard);